import Vue from 'vue'
import Vuex from 'vuex'
import gui from '@/store/modules/gui'
import app from '@/store/modules/app'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    gui,
    app
  }
})
